import React from 'react';

/**
 * @param {function} callback
 * @param {number} delay
 * @param {number} limit
 */
export const useInterval = (callback, delay, limit) => {
  const intervalIdRef = React.useRef(null);
  const count = React.useRef(0);

  const func = () => {
    if (limit && count.current >= limit) {
      return clearInterval(intervalIdRef.current);
    }
    count.current++;
    return callback();
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    intervalIdRef.current = setInterval(func, delay);
    return () => clearInterval(intervalIdRef.current);
  }, [callback, delay]);
};
